var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4996 17.7082C14.7568 17.7082 18.2079 14.257 18.2079 9.99984C18.2079 5.74264 14.7568 2.2915 10.4996 2.2915C6.2424 2.2915 2.79126 5.74264 2.79126 9.99984C2.79126 14.257 6.2424 17.7082 10.4996 17.7082Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9336 12.2915C13.1336 13.3082 11.8919 13.9582 10.5002 13.9582C9.10856 13.9582 7.86689 13.3082 7.06689 12.2915",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00041 8.95833C8.5757 8.95833 9.04207 8.49196 9.04207 7.91667C9.04207 7.34137 8.5757 6.875 8.00041 6.875C7.42511 6.875 6.95874 7.34137 6.95874 7.91667C6.95874 8.49196 7.42511 8.95833 8.00041 8.95833Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0004 8.95833C13.5757 8.95833 14.0421 8.49196 14.0421 7.91667C14.0421 7.34137 13.5757 6.875 13.0004 6.875C12.4251 6.875 11.9587 7.34137 11.9587 7.91667C11.9587 8.49196 12.4251 8.95833 13.0004 8.95833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyIcon);
export default __webpack_public_path__ + "static/media/happy-icon.fd6225764704d1b163cf6e9bb7b6470c.svg";
export { ForwardRef as ReactComponent };